import script from "./Signin.vue?vue&type=script&setup=true&lang=js"
export * from "./Signin.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__